export default __webpack_public_path__ + "static/media/the-forbidden-act.7b05aef1.jpg";